"use client";

import { useState } from "react";

import { signIn } from "@revana/auth/react";
import { Button, Icon, type ButtonProps } from "@revana/ui";

const GoogleAuthButton: React.FC<
  ButtonProps & {
    redirectUrl?: string;
  }
> = ({ redirectUrl, ...props }) => {
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);

  const handleGoogleAuthClick = () => {
    setIsGoogleLoading(true);
    void signIn("google", {
      callbackUrl: redirectUrl ?? "/",
    });
  };

  return (
    <Button
      className="w-full min-w-[199px]"
      loading={isGoogleLoading}
      preIcon={<Icon className="h-4 w-4" name="google" />}
      variant="tertiary"
      onClick={handleGoogleAuthClick}
      {...props}
    >
      Continue with Google
    </Button>
  );
};

export default GoogleAuthButton;
